import React from 'react';

export type CSRFContextValue = string | null;
const defaultContext: CSRFContextValue = null;

const CSRFContext = React.createContext<CSRFContextValue>(defaultContext);
CSRFContext.displayName = 'CSRFContext';

export const CSRFProvider = CSRFContext.Provider;

export function useCSRFToken(): CSRFContextValue {
  return React.useContext(CSRFContext);
}
